import type { ModulatorCsId, ModulatorHwId } from "~domain/devices/models/modulators/modulator-model.ts";
import type { PilotHwId } from "~domain/devices/models/pilot/pilot-model.ts";
import type { InstallTestV2V5Id } from "~domain/install-tests/models/v2v5/install-test-v2v5-model.ts";
import type { OperatorId } from "~domain/operators/models/operator-model.ts";
import type { SiteId } from "~domain/sites/models/site-model.ts";

import { z } from "zod";

export const backofficeFindV2v5InstallTestsResponseSchema = z
  .object({
    dateSent: z.coerce.date(),
    installTestId: z.number().transform((s) => s as InstallTestV2V5Id),
    modulatorCsId: z
      .number()
      .transform((s) => s as ModulatorCsId)
      .nullable(),
    modulatorId: z.number().transform((s) => s as ModulatorHwId),
    momboxId: z.number().transform((s) => s as PilotHwId),
    origin: z.number(),
    siteId: z.number().transform((s) => s as SiteId),
    testerId: z.number().transform((s) => s as OperatorId),
    testerName: z.string(),
  })
  .array();

export type BackofficeFindV2v5InstallTestsResponse = z.infer<typeof backofficeFindV2v5InstallTestsResponseSchema>;
